import { connect } from 'react-redux'

import { TotalSection } from '@components/order/edit/sections'

import services from '@services'
import coordinators from '@coordinators'
import presenters from '@presenters'

const mapStateToProps = (state) => {
  const errors = state.errors.editOrderModal || {}
  const { lastLoggedInHq: headquarterId, permissions } = state.user || {}
  const userPermissions = permissions[headquarterId]

  return {
    errors,
    userPermissions,
  }
}

const mapDispatchToProps = () => {
  const {
    OrderService,
    RestService,
    RouterService,
    SessionService,
    SettingsService,
    UIService,
  } = services
  const { displayFailureMessage } = UIService.FlashMessage
  const {
    AsyncLoadTaxRates,
    RetryOnTimeout,
    HandleError: HandleError_,
  } = coordinators
  const { pResponseGeneric } = presenters.Api
  const { pResponseOrderGetTaxRate } = presenters.Errors

  const {
    calculateChefAmount,
    calculateDeliveryFee,
    calculateDiscounts,
    calculateGrossMargin,
    calculatePreTaxTotal,
    calculateServiceFee,
    calculateStaffingFee,
    calculateSubtotal,
    calculateTax,
    calculateTip,
    calculateTotal,
  } = OrderService
  const HandleError = HandleError_({
    RouterService,
    SessionService,
    UIService,
    pResponseError: pResponseOrderGetTaxRate,
  })
  const getTaxRates = AsyncLoadTaxRates({
    RestService,
    SettingsService,
    pResponseGeneric,
    RetryOnTimeout,
    HandleError,
  })

  return {
    calculateChefAmount,
    calculateDeliveryFee,
    calculateDiscounts,
    calculateGrossMargin,
    calculatePreTaxTotal,
    calculateServiceFee,
    calculateStaffingFee,
    calculateSubtotal,
    calculateTax,
    calculateTip,
    calculateTotal,
    displayFailureMessage,
    getTaxRates,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TotalSection)
